module.exports = __webpack_public_path__ + "static/media/login.fe1e77d5.jpg";